import { Injectable } from '@angular/core';
import { ConfirmDialogModel } from '../models/confirm-dialog.model';
import { UiConfirmDialogComponent } from '../ui-kit/ui-confirm-dialog/ui-confirm-dialog.component';
import { map, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { UiConfirmNameModalComponent } from '../ui-kit/ui-confirm-name-modal/ui-confirm-name-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  constructor(
    private dialog: MatDialog,
    private translateService: TranslateService,
  ) {}

  public open(
    options: ConfirmDialogModel.ConfirmDialogOptions,
    minHeight?: number,
  ): Observable<ConfirmDialogModel.ConfirmDialogResult | undefined> {
    return this.dialog
      .open<
        UiConfirmDialogComponent,
        ConfirmDialogModel.ConfirmDialogOptions,
        ConfirmDialogModel.ConfirmDialogResult
      >(UiConfirmDialogComponent, {
        minWidth: '400px',
        maxWidth: '450px',
        minHeight: minHeight !== undefined ? `${minHeight}px` : undefined,
        data: options,
        disableClose: options.disableClose,
        panelClass: ['modal-no-padding', 'z-index-1001'],
      })
      .afterClosed();
  }

  public discard(): Observable<boolean> {
    const title: string = this.translateService.instant(
      'CONFIRM_POPUP.TITLE',
    ) as string;
    const msg: string = this.translateService.instant(
      'CONFIRM_POPUP.MSG',
    ) as string;
    const confirm: string = this.translateService.instant(
      'CONFIRM_POPUP.LEAVE',
    ) as string;
    const cancel: string = this.translateService.instant(
      'CONFIRM_POPUP.CANCEL',
    ) as string;

    return this.open(
      {
        title,
        msg,
        type: ConfirmDialogModel.ConfirmDialogType.CONFIRM,
        confirm,
        cancel,
        disableClose: true,
      },
      200,
    ).pipe(
      map(
        (res: ConfirmDialogModel.ConfirmDialogResult | undefined): boolean => {
          if (!res?.selection) {
            return false;
          }
          return true;
        },
      ),
    );
  }

  public openNameConfirm(
    options: ConfirmDialogModel.Options,
  ): Observable<ConfirmDialogModel.ConfirmResult | undefined> {
    return this.dialog
      .open<
        UiConfirmNameModalComponent,
        ConfirmDialogModel.Options,
        ConfirmDialogModel.ConfirmResult
      >(UiConfirmNameModalComponent, {
        minWidth: '400px',
        maxWidth: '450px',
        data: options,
        disableClose: options.disableClose,
        panelClass: ['modal-no-padding', 'z-index-1001'],
      })
      .afterClosed();
  }
}
